// tab — wireframe skin module
// Token disposition: color tokens overridden to wf-* namespace; spacing/sizing pass-through

export const styles = `
  :host {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    position: relative;
    min-width: var(--run-tab-min-width, 4rem);
    padding-block: var(--run-tab-padding-block, var(--run-space-semantic-xs));
    padding-inline: var(--run-tab-padding-inline, var(--run-space-semantic-xs));
    gap: var(--run-tab-gap, var(--run-space-semantic-xs));
    background: var(--run-wf-surface);
    color: var(--run-wf-text);
    font-size: var(--run-tab-font-size, var(--run-font-size-base));
    font-weight: 400;
    font-family: var(--run-wf-font-family);
    line-height: var(--run-tab-line-height, var(--run-font-semantic-line-height-body));
    border-radius: var(--run-tab-radius, var(--run-radius-semantic-control));
    border-bottom: 1px dashed var(--run-wf-border);
    cursor: pointer;
    box-sizing: border-box;
    transition: none;
    -webkit-tap-highlight-color: transparent;
    user-select: none;
  }

  :host(:hover:not([aria-disabled="true"])) {
    background: var(--run-wf-surface-hover);
    color: var(--run-wf-text-interactive);
  }

  :host(:focus-visible) {
    outline: 2px dashed var(--run-wf-border-focus);
    outline-offset: 2px;
  }

  [part="base"] {
    display: inline-flex;
    align-items: center;
    gap: var(--run-tab-gap, var(--run-space-semantic-xs));
    position: relative;
    width: 100%;
  }

  [part="base"][data-active] {
    color: var(--run-wf-text-interactive);
    font-weight: 400;
  }

  [part="base"][data-disabled] {
    opacity: 0.48;
    cursor: not-allowed;
  }

  [part="icon"] {
    display: inline-flex;
    align-items: center;
    flex-shrink: 0;
    width: var(--run-tab-icon-size, var(--run-size-icon-md));
    height: var(--run-tab-icon-size, var(--run-size-icon-md));
  }

  [part="label"] {
    flex: 1 1 auto;
    min-width: 0;
  }

  [part="badge"] {
    flex-shrink: 0;
  }

  [part="close-trigger"] {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    width: var(--run-tab-icon-size, var(--run-size-icon-md));
    height: var(--run-tab-icon-size, var(--run-size-icon-md));
    padding: 0;
    margin: 0;
    background: transparent;
    border: 1px dashed var(--run-wf-border);
    border-radius: var(--run-tab-radius, var(--run-radius-semantic-control));
    color: inherit;
    cursor: pointer;
    line-height: 1;
    font-size: var(--run-tab-font-size, var(--run-font-size-base));
  }

  [part="close-trigger"]:hover {
    background: var(--run-wf-surface-hover);
  }

  [part="close-trigger"]:focus-visible {
    outline: 2px dashed var(--run-wf-border-focus);
    outline-offset: 1px;
  }

  [part="indicator"] {
    position: absolute;
    bottom: calc(-1 * var(--run-tab-indicator-width, 2px));
    left: 0;
    right: 0;
    height: var(--run-tab-indicator-height, 2px);
    background: transparent;
    border-radius: 1px;
    transition: none;
  }

  [part="base"][data-active] [part="indicator"] {
    background: var(--run-wf-accent);
  }

  :host(:hover:not([aria-disabled="true"])) [part="base"]:not([data-active]) [part="indicator"] {
    background: var(--run-wf-border);
  }
`;

export function render(host) {
  const { panel, active, disabled, closable, label, icon, badge } = host;

  const activeAttr = active ? ' data-active="true"' : '';
  const disabledAttr = disabled ? ' data-disabled="true"' : '';
  const closableAttr = closable ? ' data-closable="true"' : '';

  const iconHtml = icon
    ? `<run-icon part="icon" name="${icon}" aria-hidden="true"></run-icon>`
    : '';

  const badgeHtml = badge !== undefined
    ? `<run-badge part="badge" aria-hidden="true">${badge}</run-badge>`
    : '';

  const closeTriggerHtml = closable
    ? `<button part="close-trigger" aria-label="Close ${label}" type="button">&#x2715;</button>`
    : '';

  host.shadowRoot.innerHTML = `
    <span part="base"${activeAttr}${disabledAttr}${closableAttr}>
      ${iconHtml}
      <run-text part="label"><slot>${label}</slot></run-text>
      ${badgeHtml}
      ${closeTriggerHtml}
      <span part="indicator"></span>
    </span>
  `;
}